import { Component, Signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService, LoginGovFormData } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { ContentComponent } from '../../components/content/content.component';
import { SpinnerComponent } from '../../common/spinner/spinner.component';
import { AlertComponent } from '../../common/alert/alert.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-goto-login-gov-page',
  standalone: true,
  imports: [
    CommonModule,
    ContentComponent,
    SpinnerComponent,
    AlertComponent
  ],
  templateUrl: './goto-login-gov-page.component.html'
})
export class GotoLoginGovPageComponent {

  public error: HttpErrorResponse | null = null;

  public data: Signal<LoginGovFormData | undefined> = toSignal(this.authService.getLoginFormData());

  constructor(private authService: AuthService) {
  }
}
